class ArticleContent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.insertMidStreamCta();
  }

  insertMidStreamCta() {
    const ctaTemplates = document.querySelectorAll(".mid-stream-cta-content");
    if (ctaTemplates.length === 0) return;
    const elementsToReplace = this.querySelectorAll(".mid-stream-cta");
    if (elementsToReplace.length === 0) return;

    elementsToReplace.forEach((element, index) => {
      const ctaTemplate = ctaTemplates[index];

      if (!(ctaTemplate instanceof HTMLTemplateElement)) return;

      const ctaContent = ctaTemplate.content.cloneNode(true);
      element.replaceWith(ctaContent);
    });
  }
}

if (!customElements.get("article-content")) {
  customElements.define("article-content", ArticleContent);
}
